import PropTypes from 'prop-types';
import { useSyncDynamicState } from '../hooks/dynamicWidgetHooks';
import { useSyncIFrameHeight } from '../hooks/syncIFrameHeightHooks';
import { Frame } from './Frame';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  name: PropTypes.string.isRequired,
  onContent: PropTypes.func,
  onError: PropTypes.func,
  onNoContent: PropTypes.func,
  onVideoEngagement: PropTypes.func,
  onVideoFinish: PropTypes.func,
  onVideoPlay: PropTypes.func,
  portalId: PropTypes.string,
  prompt: PropTypes.string.isRequired,
  strategy: PropTypes.oneOf(['comprehensive', 'fast']).isRequired
};
export const DynamicContentWidget = ({
  prompt,
  name,
  strategy,
  onContent,
  onError,
  onNoContent,
  onVideoPlay,
  onVideoFinish,
  onVideoEngagement
}) => {
  const {
    registerIFrame: registerSyncHeight,
    height
  } = useSyncIFrameHeight();
  const {
    registerIFrame: registerSyncDynamic
  } = useSyncDynamicState({
    newState: {
      prompt,
      strategy
    },
    onContent,
    onError,
    onNoContent,
    onVideoPlay,
    onVideoFinish,
    onVideoEngagement
  });
  return /*#__PURE__*/_jsx(Frame, {
    height: height,
    name: name,
    refHandlers: [registerSyncHeight, registerSyncDynamic],
    targetWidget: "dynamic"
  });
};
DynamicContentWidget.propTypes = propTypes;
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
DynamicContentWidget.defaultProps = {
  strategy: 'comprehensive'
};